module.exports = __webpack_public_path__ + "img/120.found_another.fb258e32.svg";